const cases = [
  { icon: "ri-map-2-line", color: "bg-violet-50 border-violet-100", iconColor: "text-violet-600 bg-violet-100", city: "某省会城市街道办", scale: "辖区人口 12万", result: "网格化管理覆盖100%辖区，事件平均响应时效从 3.2天 压缩至 4.2小时，居民满意度提升 28个百分点。" },
  { icon: "ri-building-4-line", color: "bg-amber-50 border-amber-100", iconColor: "text-amber-600 bg-amber-100", city: "某县城社区治理项目", scale: "15个社区 · 8万人口", result: "通过人口房屋信息库整合，基层人员核查工作量减少 62%，独居老人关怀覆盖率从 41% 提升至 93%。" },
  { icon: "ri-shield-star-line", color: "bg-rose-50 border-rose-100", iconColor: "text-rose-600 bg-rose-100", city: "某工业园区安全管理", scale: "入驻企业 340家", result: "基础设施巡查频次提升 3倍，隐患自动识别率 86%，安全事故发生率同比下降 74%，获评省级示范。" },
  { icon: "ri-customer-service-2-line", color: "bg-teal-50 border-teal-100", iconColor: "text-teal-600 bg-teal-100", city: "某市12345热线数字化", scale: "日均处理诉求 2,400件", result: "民情诉求智能分类准确率 94%，自动派发工单减少人工操作 78%，诉求办结率提升至 97.3%。" },
];

export default function GGCases() {
  return (
    <section className="py-20 px-8" style={{ background: "#faf7ff" }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-violet-600 tracking-widest uppercase mb-2 block">Implementation Cases</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">政务落地案例</h2>
          <p className="text-slate-500 text-sm">已在省市县各级政府机构成功部署运营</p>
        </div>
        <div className="grid grid-cols-2 gap-6">
          {cases.map((c) => (
            <div key={c.city} className={`rounded-2xl p-6 border ${c.color} cursor-pointer hover:shadow-sm transition-all`}>
              <div className="flex items-start gap-4">
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${c.iconColor}`}>
                  <i className={`${c.icon} text-xl`}></i>
                </div>
                <div>
                  <div className="font-semibold text-slate-800 text-sm mb-0.5">{c.city}</div>
                  <div className="text-slate-400 text-xs mb-3">{c.scale}</div>
                  <p className="text-slate-600 text-sm leading-relaxed">{c.result}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
